import React, { useState } from "react";
import { Resource } from "../Resource";
import { useSyncActive } from "../../../utils/useSyncActive";

export const CreateResources: React.FC = () => {
  const [openModalAvailability, setOpenModalAvailability] = useState<boolean>(false);

  const isSyncActive = useSyncActive();

  return (
    <>
      <div>
        <Resource pageType="create" setOpenModalAvailability={setOpenModalAvailability} isSyncActive={isSyncActive}/>
      </div>
    </>
  );
};